import { EvidenceToControlMappingInfo } from '@trustero/trustero-api-web/lib/evidencemgmt/evidencemgmt_pb'
import {
  GridColumnSortEvidenceControlMapping,
  GridColumnSortType,
} from 'src/components/Reusable/Grid/GridColumnSort/GridColumnSort.constants'

export const sortEvidenceControlMappings = (
  mappings: EvidenceToControlMappingInfo[],
  sortCol: GridColumnSortEvidenceControlMapping,
  sortType: GridColumnSortType,
): EvidenceToControlMappingInfo[] => {
  return [...mappings].sort((a, b) => {
    let comparison = 0
    switch (sortCol) {
      case GridColumnSortEvidenceControlMapping.EVIDENCE:
        comparison = (a.getEvidence()?.getCaption() || '').localeCompare(
          b.getEvidence()?.getCaption() || '',
        )
        break
      case GridColumnSortEvidenceControlMapping.LINKED_CONTROLS:
        comparison =
          a.getLinkedControlsList().length - b.getLinkedControlsList().length
        break
      case GridColumnSortEvidenceControlMapping.SUGGESTED_CONTROLS:
        comparison =
          a.getSuggestedControlsList().length -
          b.getSuggestedControlsList().length
        break
    }
    return sortType === GridColumnSortType.ASCENDING ? comparison : -comparison
  })
}
